import { render } from "./App.vue?vue&type=template&id=f446c410"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=f446c410&lang=css"

import exportComponent from "/Users/animatik/Sites/Vitalhit/Pay/id/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__